import { apiUrl } from "@/lib/api-config";
import { getJwtToken } from "@/lib/auth-client";

export async function resetWriteAssistantThread(
  apiPathPrefix: string,
  body?: Record<string, unknown>
): Promise<void> {
  const token = await getJwtToken();
  const response = await fetch(apiUrl(`${apiPathPrefix}/reset-thread`), {
    method: "POST",
    credentials: "include",
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Reset failed (${response.status})`);
  }
}
